module.exports = __webpack_public_path__ + "img/Gefahr_durch_Explosivstoffe.bf948991.svg";